export class FiltersModel {
  valueType: any = null;
  scheduleType = 'CreatedDate';
  nameType = 'ContainerNo';
}
